<template>
  <div>
    <div class="container">
      <h1 class="page-title text-center mt-5">Xilda Story</h1>
      <h2 class="sub-title text-center mb-4 mb-md-5" v-html="$t('message.blogsubtitle')"></h2>

      <div class="row mb-3" v-if="!isContentsLoaded">
        <div class="col-12 col-md-6 placeholder" v-for="index in 2" :key="index">
          <div class="blog-article">
            <div class="thumbnail mb-3"></div>
            <div class="paragraph mb-4" style="width: 30%;"></div>
            <div class="paragraph mb-2" style="width: 100%;"></div>
            <div class="paragraph" style="width: 80%;"></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div :class="['col-12']" v-for="(post) in stickyPosts" :key="post.id">
            <router-link :to="{ name: 'BlogDetail', params: { slug: decodeURIComponent(post.slug) } }">
              <div :class="['blog-article', 'picked']" :id="`blog-article-${post.id}`">
                <div class="thumbnail">
                  <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" :style="{ backgroundImage: `url(${post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url})` }"></div>
                  <!-- /.thumbnail-media -->
                </div>
                <!-- /.thumbnail -->
                <div class="blog-desc">
                  <div class="category" v-html="categoryName"></div>
                  <div class="description" v-html="post.title.rendered"></div>
                  <p class="d-none d-md-block" v-html="`${$t('message.by')} ${post._embedded.author[0].name}`" v-if="post._embedded.author[0]"></p>
                  <p class="event-schedule d-none d-md-block" v-html="dateFormat(post.date)"></p>
                </div>
                <!-- /.blog-desc -->
              </div>
              <!-- /.blog-article -->
            </router-link>
          </div>

          <div :class="['col-12', 'col-md-6']" v-for="(post) in contents" :key="post.id">
            <router-link :to="{ name: 'BlogDetail', params: { slug: decodeURIComponent(post.slug) } }">
              <div :class="['blog-article']" :id="`blog-article-${post.id}`">
                <div class="thumbnail">
                  <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" :style="{ backgroundImage: `url(${post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url})` }"></div>
                  <!-- /.thumbnail-media -->
                </div>
                <!-- /.thumbnail -->
                <div class="blog-desc">
                  <div class="category" v-html="categoryName"></div>
                  <div class="description" v-html="post.title.rendered"></div>
                  <p class="d-none d-md-block" v-html="`${$t('message.by')} ${post._embedded.author[0].name}`" v-if="post._embedded.author[0]"></p>
                  <p class="event-schedule d-none d-md-block" v-html="dateFormat(post.date)"></p>
                </div>
                <!-- /.blog-desc -->
              </div>
              <!-- /.blog-article -->
            </router-link>
          </div>
        </div>
        <div class="row my-5" v-if="totalpages > 1">
          <div class="col text-center">
            <button type="button" :class="['btn', currentpage === index ? 'dark' : 'light', 'mr-3', 'pagination', isButtonLoading ? 'disabled': '']" :disabled="isButtonLoading" @click="getContents(index)" v-for="(index) in totalpages" :key="index">{{ index }}</button>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
export default {
  name: 'XildaStory',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      isContentsLoaded: false,
      categoryName: '',
      contents: [],
      stickyPosts: [],
      page: null,
      per_page: 12,
      currentpage: this.$route.query.paged || 1,
      totalpages: 0,
      isButtonLoading: true
    }
  },
  mounted () {
    document.title = `Xilda Story - ${this.title}`
    this.getContents(this.currentpage)
  },
  methods: {
    async getContents (page = 1) {
      const lang = this.$route.params.lang
      const $vm = this
      axios.get(`${$vm.api_path}wp-json/wp/v2/categories`, {
        params: {
          slug: 'blog'
        }
      })
        .then(cat => {
          const catId = cat.data[0].id
          $vm.categoryName = cat.data[0].name
          axios.get(`${$vm.api_path}wp-json/wp/v2/posts`, {
            params: {
              _embed: true,
              categories: catId,
              per_page: $vm.per_page,
              sticky: false,
              page,
              lang
            }
          })
            .then(async res => {
              if (page === 1) {
                const stickyposts = await $vm.getStickyPosts(catId, page)
                if (stickyposts.headers['x-wp-total'] > 0) {
                  $vm.stickyPosts = stickyposts.data
                }
              }
              $vm.contents = res.data
              $vm.isContentsLoaded = true
              $vm.totalpages = parseInt(res.headers['x-wp-totalpages'])
              $vm.$router.push({ query: { paged: page } })
              $vm.currentpage = parseInt(page)
              $vm.page = parseInt(page) + 1
              $vm.isButtonLoading = false
            })
        })
    },
    async getStickyPosts (catId, page) {
      const lang = this.$route.params.lang
      const $vm = this
      const stickyPosts = await axios.get(`${$vm.api_path}wp-json/wp/v2/posts`, {
        params: {
          _embed: true,
          categories: catId,
          per_page: $vm.per_page,
          page,
          sticky: true,
          lang
        }
      })
      return stickyPosts
    },
    dateFormat (date, format = 'D MMMM YYYY') {
      const lang = this.$route.params.lang
      return dayjs(date).locale(lang).format(format)
    }
  }
}
</script>
